import { useMemo } from 'react'

import { y } from '@circlefin/form'
import useTranslation from 'next-translate/useTranslation'

import { L3OnboardingRadioCardGroup } from '../../L3OnboardingRadioCardGroup'

import type {
  L3OnboardingRadioCardGroupProps,
  RadioCardItem,
} from '../../L3OnboardingRadioCardGroup'

export type AtmTypeOptionsType = 'unidirectional' | 'bidirectional' | ''

export const atmSchema = y
  .mixed<AtmTypeOptionsType>()
  .oneOf(['unidirectional', 'bidirectional'])

export type AtmTypeProps = Omit<
  L3OnboardingRadioCardGroupProps<AtmTypeOptionsType>,
  'options'
>

/**
 * Circle L3 Onboarding AtmType Radio Card Group.
 */
export const AtmType: React.FC<AtmTypeProps> = (props) => {
  const { t } = useTranslation('l3Onboarding')
  const options: RadioCardItem<AtmTypeOptionsType>[] = useMemo(
    () => [
      {
        label: t`forms.entityOperations.offersAtmType.options.unidirectional`,
        value: 'unidirectional',
      },
      {
        label: t`forms.entityOperations.offersAtmType.options.bidirectional`,
        value: 'bidirectional',
      },
    ],
    [t],
  )

  return <L3OnboardingRadioCardGroup {...props} options={options} />
}
